import type { ExcIceCorpactionsV1ActionKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../../../util/routing/entity-paths';

export const ICE_CA_ACTION_BASE_PATH = getResolvedPath('/clearing/vendor/ice/corporate-action');

export const getIceCaActionPath: EntityPathBuilder<ExcIceCorpactionsV1ActionKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return ICE_CA_ACTION_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.eventId) {
        return undefined;
      }

      return getResolvedPath(`${ICE_CA_ACTION_BASE_PATH}/$eventId`, context.keys);
    }
  }
};

export function getIceCaActionDetailPath(eventId: string | undefined) {
  if (!eventId) {
    return undefined;
  }

  return getIceCaActionPath({ kind: 'detail', keys: { eventId } });
}
